import { IResource } from '@gettactic/api';
import { useMap } from '@webV2/map/MapProvider';
import Image from 'next/image';
import { useEffect } from 'react';
import { MapViewEmbedded } from '@webV2/map/MapView/MapViewEmbedded';

export const MapWithMiniOfficePhoto = ({
  resourceId,
  officeId,
  parentId,
  startDate,
  resourceImage
}: {
  resourceId: string;
  officeId: string;
  parentId: string;
  startDate: string;
  resourceImage: string | undefined;
}) => {
  return (
    <div
      className="relative h-[324px] overflow-hidden rounded-sm border-1 border-neutral-100 bg-neutral-50"
      // key is required here to rerender the map for another schedule
      key={resourceId}
    >
      {resourceImage && (
        <div className="absolute bottom-[8px] left-[8px] z-10 h-[75px] w-[110px] rounded-lg bg-neutral-50">
          <Image
            src={resourceImage}
            alt="Office Photo"
            className="rounded-lg"
            width={110}
            height={75}
          />
        </div>
      )}
      <MapViewEmbedded
        officeId={officeId}
        floorId={parentId}
        focussedResourceId={resourceId}
        date={startDate}
        enableControls
      />
    </div>
  );
};

export const MapWithProvider = ({
  resourceId,
  children
}: {
  resourceId: string;
  children: React.ReactNode;
}) => {
  const { events } = useMap();

  useEffect(() => {
    events.trigger(
      'onHighlightUserResource',
      // we only really need an id
      [{ resource: resourceId }] as unknown as IResource[]
    );
  }, [resourceId]);

  return resourceId ? children : null;
};
